import { useEffect } from "react";
import BroadcastClipsTable from "@/components/discovery/broadcast-clips-table/BroadcastClipsTable";
import BroadcastClipsTabContentManagementPanel from "@/components/discovery/discovery-content-control-panels/BroadcastClipsTabContentManagementPanel";
import useDiscoveryContentManagementStore from "@/store/discovery/discovery-content-management/discovery-content-management.slice";

const BroadcastClipsTab = () => {
  useEffect(() => {
    return () => {
      const { resetBroadcastClipsTableState, setBroadcastClipsSearchTerm } =
        useDiscoveryContentManagementStore.getState();
      resetBroadcastClipsTableState();
      setBroadcastClipsSearchTerm("");
    };
  }, []);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <BroadcastClipsTabContentManagementPanel />
      <div className="min-h-0 flex-1">
        <BroadcastClipsTable />
      </div>
    </div>
  );
};

export default BroadcastClipsTab;
